<div [ngStyle]="{'background-color': color}" (click)="click()" fxLayout="column" fxLayoutAlign="center center" class="button">
    <span>
        {{text}}
    </span>
</div>
<span class="error" *ngIf="error">{{error}}</span>